import React, { Component } from 'react'
import FormMixin from 'containers/shared/FormMixin'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { NominationActions, SnackbarActions } from 'actionsets'
import { ConfirmationDialog } from 'components'
import ErrorObject from 'containers/shared/ErrorObject'
import { Formatters } from 'utils'

export class NominationDialog extends FormMixin(Component){
  static propTypes = {
    dealSheet: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    onNominationAdded: PropTypes.func,
  }

  static defaultProps = {
    onClose: () => {},
    onNominationAdded: () => {},
  }

  constructor(props){
    super(props)
    this.state = {
      attributes: {}
    }
    this.errorObject = new NominationErrorObject(this)
    this.onSaveRoute = null

    NominationActions.bindActions(this)
    SnackbarActions.bindActions(this, 'snackbar')
  }

  get formObject(){
    return { dealSheetId: this.props.dealSheet.id }
  }

  get createMode(){
    return true
  }

  get formObjectName(){
    return 'Nomination'
  }

  resetState = () => {
    this.setState({
      attributes: {}
    })
  }

  handleConfirm = async () => {
    try {
      const updated = this.updatedFormObject
      await this.saveAction(updated)
      this.props.onClose()
      this.actions.snackbar.success(`Nomination for ${this.attribute('email')} created!`)
      this.resetState()
      this.props.onNominationAdded()
    } catch(err) {
      this.actions.snackbar.error('Failed to create nomination!')
    }
  }

  handleCancel = () => {
    this.resetState()
    this.props.onClose()
  }

  get numberOfTokens(){
    const size = parseFloat(this.attribute('size')) || 0
    const privateRate = parseFloat(this.props.dealSheet.preSaleRate)
    const count = size * privateRate
    return count
  }

  get totalSupply() {
    const { preSaleTokenAmount, publicSaleTokenAmount, remainingTokenAmount } = this.props.dealSheet
    return Number(preSaleTokenAmount) + Number(publicSaleTokenAmount) + Number(remainingTokenAmount)
  }

  get numberOfTokensLabel(){
    return isNaN(this.numberOfTokens) ? '' : `Approx: ${Formatters.numberWithMaxPrecision(this.numberOfTokens)} ${this.props.dealSheet.ticker}`
  }

  renderRate = (rate) => {
    return `${rate} ${this.props.dealSheet.ticker} per ${this.props.dealSheet.currency.code}`
  }

  get isProduct() {
    return this.props.dealSheet.typeOfIssuance === 'product'
  }

  get name() {
    return this.isProduct ? 'RFQ' : 'nomination'
  }

  render() {
    const { Card, LargeNumberField, TextField } = this
    return (
      <ConfirmationDialog
          open={this.props.open}
          title={`Create new ${this.name}`}
          onConfirm={this.handleConfirm}
          onCancel={this.handleCancel}
          canConfirm={
            !!(this.attribute('email').trim()
              && this.attribute('size').trim())
          }>
        <Card>
          {this.isProduct ? (
            <Typography variant='body1'>
              Please indicate the quantity you would like to request a quote for on behalf of this investor
            </Typography>
          ) : (
            <Typography variant='body1'>
              Please indicate up to how many tokens you would like to nominate for this investor
            </Typography>
          )}
          <br/>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>Total supply({this.props.dealSheet.ticker})</TableCell>
                <TableCell>{this.totalSupply} {this.props.dealSheet.ticker}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Pre sale supply({this.props.dealSheet.ticker})</TableCell>
                <TableCell>{this.props.dealSheet.preSaleTokenAmount} {this.props.dealSheet.ticker}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Pre sale rate</TableCell>
                <TableCell>{ this.renderRate(this.props.dealSheet.preSaleRate) }</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Public sale rate</TableCell>
                <TableCell>{ this.renderRate(this.props.dealSheet.publicSaleRate) }</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <TextField attribute='email' label='Email' type='email' />
          <LargeNumberField attribute='size' label={`Amount (${this.props.dealSheet.currency.code})`}/>
          <TextField disabled value={this.numberOfTokensLabel}/>
        </Card>
      </ConfirmationDialog>
    )
  }
}

class NominationErrorObject extends ErrorObject {
  errorKeysForField(fieldName) {
    switch(fieldName){
      case 'email':
        return ['email', 'investorAccount']
      default:
        return [fieldName]
    }
  }

  hasError(fieldName) {
    const errorKeys = this.errorKeysForField(fieldName)
    return errorKeys.map((key) => super.hasError(key)).some((v) => v)
  }

  getError(fieldName) {
    const errorKeys = this.errorKeysForField(fieldName)
    return errorKeys.map((key) => super.getError(key)).filter((v) => !!v).join(', ')
  }
}

export default connect(({nominations}) => nominations)(NominationDialog)